import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Customer } from '../../types/Customer';
import { DataFetchError } from '../../utils/ErrorClass';

export const useCustomer = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const itemsPerPage = 100;

  const fetchCustomers = useCallback(async (page: number, query: string = '') => {
    setLoading(true);
    const startIdx = (page - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage - 1;

    try {
      const { data, error, count } = await supabase
        .from('customer')
        .select('*', { count: 'exact' })
        .ilike('name', `%${query}%`)
        .is('deleted_at', null)
        .order('id', { ascending: true })
        .range(startIdx, endIdx);

      if (error) {
        throw new DataFetchError("データの取得失敗: " + error.message);
      }

      setCustomers(data as Customer[]);
      setTotalPages(Math.ceil((count ?? 0) / itemsPerPage));
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCustomers(page, searchQuery);
  }, [page, searchQuery, fetchCustomers]);

  return { customers, page, totalPages, setPage, setSearchQuery, loading, error };
};
